export default __webpack_public_path__ + "static/media/menu-03-statistics-w.9a7ea39a.svg";